import InformationMessage from "../InformationMessage";
import { TextField } from "@ploy-ui/form-fields";
import { defineMessages, useIntl } from "react-intl";
import { LoginResource } from "@ploy-lib/rest-resources";
import { useFetcher } from "@rest-hooks/core";
import { FormBase } from "@ploy-ui/login";
import { ErrorDisplay } from "@ploy-lib/types";

export const messages = defineMessages({
	usernamePlaceholder: {
		id: "dealer.login.field.username.placeholder",
		description: "Placeholder for email field",
		defaultMessage: "E-mail address"
	},
	usernameLabel: {
		id: "dealer.login.field.username.label",
		description: "Label for email field",
		defaultMessage: "E-mail address"
	},
	passwordPlaceholder: {
		id: "dealer.login.field.password.placeholder",
		description: "Placeholder for password field",
		defaultMessage: "Password"
	},
	passwordLabel: {
		id: "dealer.login.field.password.label",
		description: "Label for password field",
		defaultMessage: "Password"
	},
	submitButtonText: {
		id: "dealer.login.button.login.label",
		description: "Label for login button",
		defaultMessage: "Log in"
	}
});

const LoginForm = () => {
	const login = useFetcher(LoginResource.login());

	const intl = useIntl();

	const fieldConfig = [
		{
			autoFocus: true,
			name: "username",
			component: TextField,
			type: "email",
			autoComplete: "username",
			placeholder: intl.formatMessage(messages.usernamePlaceholder),
			variant: "input",
			helperText: " ",
			margin: "normal",
			label: intl.formatMessage(messages.usernameLabel),
			fullWidth: true,
			errorDisplay: ErrorDisplay.Touched
		},
		{
			name: "password",
			component: TextField,
			type: "password",
			autoComplete: "current-password",
			placeholder: intl.formatMessage(messages.passwordPlaceholder),
			variant: "input",
			helperText: " ",
			margin: "normal",
			label: intl.formatMessage(messages.passwordLabel),
			fullWidth: true,
			errorDisplay: ErrorDisplay.Touched
		}
	];

	const initValues = { username: "", password: "" };

	return (
		<FormBase
			submit={values => login(undefined, values)}
			initValues={initValues}
			fieldConfig={fieldConfig}
			submitButtonText={intl.formatMessage(messages.submitButtonText)}
			forgottenPasswordLink={{ isRelative: true, link: "forgotten-password" }}
		>
			<InformationMessage />
		</FormBase>
	);
};

export default LoginForm;
